import { useMemo } from "react";
import { useTheme } from "@/contexts/theme/useTheme";
import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { FONT_FAMILY } from "@/utils/font-family";

const HP_PAPER_SX = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: "8px",
  minWidth: 206,
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 4px 16px 4px rgba(26, 26, 26, 0.2)",
  borderRadius: "8px",
  "& .MuiList-root": {
    padding: 0,
    gap: 0,
    display: "flex",
    flexDirection: "column",
  },
  "& .MuiMenuItem-root": {
    position: "relative",
    padding: "8px 12px 8px 8px",
    gap: "8px",
    minHeight: 40,
    height: 40,
    minWidth: 190,
    boxSizing: "border-box",
    isolation: "isolate",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "rgba(133, 133, 133, 0.1)",
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: "calc(50% - 6px)",
        width: 2,
        height: 12,
        background: "#3D3D3D",
        border: "2px solid #FFFFFF",
        borderRadius: 4,
        zIndex: 2,
      },
    },
    "&.Mui-selected, &:active": {
      backgroundColor: "rgba(133, 133, 133, 0.2)",
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: "calc(50% - 6px)",
        width: 2,
        height: 12,
        background: "#525252",
        border: "2px solid #FFFFFF",
        borderRadius: 4,
        zIndex: 2,
      },
    },
  },
} as const;

const HP_TRIGGER_BUTTON_SX = {
  width: 32,
  height: 32,
  minWidth: 32,
  minHeight: 32,
  padding: "6px",
  border: "none",
  borderRadius: "6px",
  color: "#1A1A1A",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "& svg": { display: "block" },
  "& path": { fill: "#1A1A1A" },
  "&:hover": { backgroundColor: "#8585851A" },
  "&.Mui-selected, &:active": { backgroundColor: "#85858533" },
} as const;

const HP_ICON_STYLE = {
  width: 20,
  height: 20,
  color: "#1A1A1A",
  "& path": { fill: "#1A1A1A" },
} as const;

const DEFAULT_ICON_STYLE = {
  width: 16,
  height: 16,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
} as const;

//!important
const useMenuStyles = () => {
  const { currentTheme } = useTheme();
  const { primaryColor, theme } = useGomakeTheme();
  const isHpClient = currentTheme === "hp-client";

  return useMemo(
    () => ({
      isHpClient,
      paperProps: isHpClient ? { sx: HP_PAPER_SX } : undefined,
      triggerButtonSx: isHpClient ? HP_TRIGGER_BUTTON_SX : {},
      iconStyle: isHpClient ? HP_ICON_STYLE : {},
      lineStyle: isHpClient
        ? undefined
        : {
            width: "100%",
            height: 1,
            backgroundColor: "#EEEEEE",
          },
      menuRowStyle: {
        display: "flex" as const,
        flexDirection: "row" as const,
        alignItems: "center",
        gap: "8px",
        width: "100%",
        minWidth: 180,
      },
      rowTextStyle: isHpClient
        ? {
            fontFamily: "Forma DJR UI, sans-serif",
            fontWeight: 400,
            fontSize: 16,
            lineHeight: "20px",
            color: "#1A1A1A",
            display: "flex" as const,
            alignItems: "center",
            flex: 1,
          }
        : {
            ...FONT_FAMILY.Lexend(500, 12),
            color: primaryColor(300),
            width: "100%",
          },
    }),
    [isHpClient, theme],
  );
};

export { useMenuStyles, HP_PAPER_SX, HP_TRIGGER_BUTTON_SX, HP_ICON_STYLE };
